<template>
  <NavBox></NavBox>
  <transition name="slide-fade">
    <router-view v-if="isRouterAlive"></router-view>
  </transition>
  <BottomBox></BottomBox>
</template>


<style >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.slide-fade {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
}
.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  top: 0;
  right: 0;
  position: absolute;
  transform: translateY(100%);
}
.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
  transform: translateY(-100%);
  z-index: 100;
}
</style>

<script>

// @ is an alias to /src
import NavBox from '/src/components/NavBox.vue'
import BottomBox from '/src/components/BottomBox.vue'

export default {
  name: 'HomeView',
  data(){
      return {
        isRouterAlive:true,
      }
    },
  provide(){
      return{
        reload:this.reload
      }
    },
  components: {
    NavBox,BottomBox
  },
  methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        });
      },
    }
}
</script>
